module.exports = __webpack_public_path__ + "img/desconto_casas_bahia.a688b85d.jpg";